export const mcpTokenConstants = {
  GET_REQUEST: "GET_MCP_TOKEN_REQUEST",
  GET_SUCCESS: "GET_MCP_TOKEN_SUCCESS",
  GET_FAILURE: "GET_MCP_TOKEN_FAILURE",
  GET_BY_ID_REQUEST: "GET_MCP_TOKEN_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_MCP_TOKEN_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_MCP_TOKEN_BY_ID_FAILURE",
  CREATE_REQUEST: "CREATE_MCP_TOKEN_REQUEST",
  CREATE_SUCCESS: "CREATE_MCP_TOKEN_SUCCESS",
  CREATE_FAILURE: "CREATE_MCP_TOKEN_FAILURE",
  UPDATE_REQUEST: "UPDATE_MCP_TOKEN_REQUEST",
  UPDATE_SUCCESS: "UPDATE_MCP_TOKEN_SUCCESS",
  UPDATE_FAILURE: "UPDATE_MCP_TOKEN_FAILURE",
};
